import React, { Component } from 'react';
import _ from 'lodash';
import { Row, Col, Card, Avatar, notification, Spin, message, Icon, Tooltip, Rate, Select} from 'antd';
import {TimeIcon,ChatIcon,ConversationImage,
    DocStethoscopeImage,DoctorConsultationMainImage,ThunderIcon,LeftChevronIcon} from '../../assets/images';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts';
const Charts = ReactHighcharts.withHighcharts(Highstock);
const { Meta } = Card;
const { Option } = Select;

class DoctorConsultations extends Component {
  constructor(props) {
      super(props);
      this.state = {
        loading: false,
        data: {},
        dropdownValue: "last_30days",
        employeeCountOverall: {filters:[], config: {}},
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      };
  }

  componentDidMount () {
    let that = this;
    this.setState({loading: true})
    window.axios.get(window.API_URL + 'corporate/doctor-consultations')
      .then(function (response) {
        console.log(response.data)
        that.setState({ 
                       loading: false,
                       data: response.data})
      })
      .catch(function (error) {
        that.setState({loading: false})
        notification['error']({
        message: 'Something Went Wrong',
        description: "Please try again later"
        })
        console.log(error);
      })
  }

  handleChange(e){
    let that = this
    that.setState({dropdownValue: e})
  }

  renderOverview(){
    sessionStorage.setItem('defaultSelectedTab', '9')
    this.props.history.push({pathname: '/overview'})
  }

  renderCardName(value){
    return(
      <h5 className="number-sub-title">{value}</h5>
    )
  }

  renderCardDesc(value){
    return(
      <h2 className="main-numbers mt-minus-12" style={{color: '#4d6189',marginBottom: 0}}>{value}</h2>
    )
  }

  renderChartTrends(){
    let that = this
    let a = that.state.dropdownValue
    if (that.state.data[a+'_total'] === 0){
      return(
        <div>
          <h1> Hello </h1>
        </div>
      )
    }else if(a === "last_30days"){
      return(
        <div>
          {this.renderDaysChart(that.state.data[a])}
        </div>
      )
    }else{
      return(
        <div>
          {this.renderChart(that.state.data[a])}
        </div>
      )
    }    
  }

  renderChart(record){
    let that = this
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(record)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.yAxis.title = {text: "Doctor Consultation Count"}
    baseConfig.config.yAxis = { allowDecimals: false} 
    baseConfig.config.xAxis = {categories: keys
                              } 
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    baseConfig.config.series = [{name: 'Doctor Consultations',data: series.map(Number),color: '#2168f3'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  renderDaysChart(record){
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.xAxis = {type: 'datetime',
                              dateTimeLabelFormats: {
                                  month: '%d. %b',
                                  year: '%b'
                                }
                              } 
    baseConfig.config.yAxis.title = {text: "Doctor Consultation Count"}   
    baseConfig.config.yAxis = { allowDecimals: false}                       
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    baseConfig.config.series = [{name: 'Doctor Consultations',data: record,color: '#2168f3'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  getColor(value){
    let color = '#ebebeb'
    if (value === 'Advices') {
      color = '#b7cfff'
    }else if(value === 'Recommended'){
      color = '#fbd38d'
    }else if(value === 'Prescriptions'){
      color = '#9ae6b4'
    }else if(value === 'LabAndPrescription'){
      color = '#fbb6ce'
    }
    return color
  }

  renderPopoverContent(percentage,text,color,subtext){
    return(
      <div>
        {subtext ? <Row type="flex" justify="start">
                   <h5 style={{color: '#a1a1a1'}}>{subtext}</h5>
                   </Row> : null }
        <Row type="flex" justify="start">
        <h5 style={{color: '#ffffff'}}>{text} </h5>
        <h5 className="semibold" style={{color: '#ffffff'}}>&nbsp; {percentage}</h5>
        </Row>
      </div>
    )
  }

  render () {
    let that = this
    const overviewLoading   = this.state.loading
    console.log(this.state)
    return(
      <div>
        {(that.state.loading || Object.keys(that.state.data).length === 0 )? <div className="spiner">
          <Spin size="large"/>
        </div> :
        <div>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <a style={{marginTop: 10}} className="flex flex-row w-full mb-2 items-center" onClick={this.renderOverview.bind(this)}><img className="mt-minus-4 chevronBackLink" style={{marginRight: 5}} src={LeftChevronIcon} /> <span className="GoBackLink" >Go Back</span></a>
            </Row>
          </Col>
        </Row>  
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h2 className = 'main-heading' style={{fontSize: 26,marginBottom: '-6px'}}>Doctor Consultations</h2>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end">
              <img src={DoctorConsultationMainImage} alt="wellness" />
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end" style={{paddingRight: 0,marginTop: 5}}>
              <h4 className="top-right-delay-label" style={{marginTop: 10}}>Refreshes every <b> 1 hour </b></h4>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Row type="flex" justify="start">
              <h3 className="sub-heading-title1" style={{color: '#8c9197',marginLeft: 2}}>AVERAGE CONSULTATION RATING</h3>
            </Row>
            <Row type="flex" justify="start" style={{marginTop: 10}}>
              <span>
                <Rate
                  allowHalf
                  disabled
                  value={that.state.data.ratings}
                  style={{color: '#2168f3'}}
                />
              </span>
            </Row>
          </Col>
          <Col span={6}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 20,maxHeight: 80}}>
              <Row type="flex" justify="start">
                <img src={TimeIcon}/>
                <h5 className="number-sub-title mt-minus-2" style={{marginLeft: 10}}>Total Consultations Time</h5>
              </Row>  
              <Row type="flex" justify="start">
                <h2 className="main-numbers mt-minus-30"  style={{color: '#8c9197',marginLeft: 50}}><span className="main-numbers" style={{color: '#2168f3'}}>{parseInt(that.state.data.total_consultation_time_min).toFixed(1).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,').replace('.0','')}</span> Min</h2>
              </Row>
            </Card>
          </Col>
          <Col span={10}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,maxHeight: 80}}>
              <Row>
                <Col span={10} style={{borderRight: '1px solid #d3dbe6',marginRight: 5,height: 40}}>
                  <Row type="flex" justify="start">
                    <img src={ThunderIcon}/>
                    <h5 className="number-sub-title mt-minus-2" style={{marginLeft: 10}}>Average Wait Time</h5>
                  </Row>  
                  <Row type="flex" justify="start">
                    <h2 className="main-numbers mt-minus-30"  style={{color: '#8c9197',marginLeft: 50}}><span className="main-numbers" style={{color: '#4d6189'}}>{parseInt(that.state.data.avg_wait_time_sec).toFixed(0)}</span> Sec</h2>
                  </Row>
                </Col> 
                <Col span={12}>
                  <Row type="flex" justify="start">
                    <img src={ChatIcon}/>
                    <h5 className="number-sub-title mt-minus-2" style={{marginLeft: 10}}>Average Consultations Time</h5>
                  </Row>  
                  <Row type="flex" justify="start">
                    <h2 className="main-numbers mt-minus-30"  style={{color: '#8c9197',marginLeft: 50}}><span className="main-numbers" style={{color: '#4d6189'}}>{parseInt(that.state.data.avg_consultation_time_min).toFixed(0)}</span> Min</h2>
                  </Row>
                </Col> 
              </Row>   
            </Card>
          </Col>
        </Row>
        <Row style={{marginTop: 60}}>
          <Col span={12}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 20,minHeight: 403}}>
              <Row>
                <Col span={14}>
                  <Row type="flex" justify="start">
                    <h3 className="font-semibold" style={{marginBottom: '-6px'}}>How Employees Utilized</h3>
                    <h5 style={{color: '#8c9197',marginTop: 5}}>Here we are showing in what ways total utilization of doctor consultation helped employees.</h5>
                  </Row>
                </Col>
                <Col span={10}>
                  <Row type="flex" justify="end">
                    <img src={DocStethoscopeImage} alt="loginsession" />
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <h4 className="semibold" style={{color: '#8c9197'}}><span className="semibold" style={{color: '#2168f3'}}>{parseInt(that.state.data.total_consultations)}</span> Doctor consultations completed till date</h4>
                </Col>
              </Row>
              <Row style={{marginTop: 30}}>
                <Col span={24}>
                  <a>
                    <svg height="20" width="100%" >
                      <rect x="0" y="5" width="100%" height="10" style={{fill: this.getColor("Default")}}/>
                      <Tooltip  title={this.renderPopoverContent((that.state.data.advices_given*100/parseInt(that.state.data.total_consultations)).toFixed(1) + '%','Advices: ',this.getColor("Advices"))}>
                        <rect x="0" y="5" id="advice_bar" width={that.state.data.advices_given*100/parseInt(that.state.data.total_consultations) + '%'} height="10" style={{fill: this.getColor("Advices")}} />
                      </Tooltip>
                      <Tooltip  title={this.renderPopoverContent((that.state.data.only_recommended_lab_tests*100/parseInt(that.state.data.total_consultations)).toFixed(1) + '%', 'Recommended Only Lab Tests: ',this.getColor("Recommended"))}>
                        <rect id="recommended_bar" x={that.state.data.advices_given*100/parseInt(that.state.data.total_consultations) + '%'} y="5" width={that.state.data.only_recommended_lab_tests*100/parseInt(that.state.data.total_consultations) + '%'} height="10" style={{fill: this.getColor("Recommended")}} />
                      </Tooltip>
                      <Tooltip  title={this.renderPopoverContent((that.state.data.only_prescription_given*100/parseInt(that.state.data.total_consultations)).toFixed(1) + '%', 'Only Prescriptions Given: ',this.getColor("Prescriptions"))}>
                        <rect id="prescription_bar" x={(parseInt(that.state.data.advices_given) + parseInt(that.state.data.only_recommended_lab_tests))*100/parseInt(that.state.data.total_consultations) + '%'} y="5" width={that.state.data.only_prescription_given*100/parseInt(that.state.data.total_consultations) + '%'} height="10" style={{fill: this.getColor("Prescriptions")}} />
                      </Tooltip>
                      <Tooltip  title={this.renderPopoverContent((that.state.data.prescription_and_lab_test*100/parseInt(that.state.data.total_consultations)).toFixed(1) + '%', 'Both Lab Tests & Prescriptions: ',this.getColor("LabAndPrescription"))}>
                        <rect id="lab_and_prescription_bar" x={(parseInt(that.state.data.advices_given) + parseInt(that.state.data.only_prescription_given) + parseInt(that.state.data.only_recommended_lab_tests) )*100/parseInt(that.state.data.total_consultations) + '%'} y="5" width={that.state.data.prescription_and_lab_test*100/parseInt(that.state.data.total_consultations) + '%'} height="10" style={{fill: this.getColor("LabAndPrescription")}} />
                      </Tooltip>
                      <rect x="0" y="15" id="advice_hover_bar" width={this.state.data.advices_given*100/parseInt(that.state.data.total_consultations) + '%'} height="4"  />
                      <rect x={that.state.data.advices_given*100/parseInt(that.state.data.total_consultations) + '%'} y="15" id="recommended_hover_bar" width={that.state.data.only_recommended_lab_tests*100/parseInt(that.state.data.total_consultations) + '%'} height="4"  />
                      <rect x={(parseInt(that.state.data.advices_given) + parseInt(that.state.data.only_recommended_lab_tests))*100/parseInt(that.state.data.total_consultations) + '%'} y="15" id="prescription_hover_bar" width={that.state.data.only_prescription_given*100/parseInt(that.state.data.total_consultations) + '%'} height="4"  />
                      <rect id="lab_and_prescription_hover_bar" x={(parseInt(that.state.data.advices_given) + parseInt(that.state.data.only_prescription_given) + parseInt(that.state.data.only_recommended_lab_tests) )*100/parseInt(that.state.data.total_consultations) + '%'} y="15" width={that.state.data.prescription_and_lab_test*100/parseInt(that.state.data.total_consultations) + '%'} height="4" />
                    </svg>
                  </a>
                </Col>
                <Col span={24} style={{marginTop: 15}}>
                  <Col sm={12}>
                    <Row type="flex" justify="start">
                      <svg height="10" width="10" style={{marginTop: 10}}>
                        <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("Advices")}}/>
                      </svg>
                      <h6 className="web-login-track">Advices</h6>
                    </Row>
                    <Row type="flex" justify="start">
                      <h2 className="number-style">{that.state.data.advices_given}</h2>
                    </Row>
                  </Col>
                  <Col sm={12}>
                    <Row type="flex" justify="start">
                      <svg height="10" width="10" style={{marginTop: 10}}>
                        <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("Recommended")}}/>
                      </svg>
                      <h6 className="web-login-track">Recommended Only Lab Tests</h6>
                    </Row>
                    <Row type="flex" justify="start">
                      <h2 className="number-style">{that.state.data.only_recommended_lab_tests}</h2>
                    </Row>
                  </Col>
                </Col>  
                <Col span={24}>  
                  <Col sm={12}>
                    <Row type="flex" justify="start">
                      <svg height="10" width="10" style={{marginTop: 10}}>
                        <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("Prescriptions")}}/>
                      </svg>
                      <h6 className="web-login-track">Only Prescriptions Given</h6>
                    </Row>
                    <Row type="flex" justify="start">
                      <h2 className="number-style">{that.state.data.only_prescription_given}</h2>
                    </Row>
                  </Col>
                  <Col sm={12}>
                    <Row type="flex" justify="start">
                      <svg height="10" width="10" style={{marginTop: 10}}>
                        <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("LabAndPrescription")}}/>
                      </svg>
                      <h6 className="web-login-track">Both Lab Tests & Prescriptions</h6>
                    </Row>
                    <Row type="flex" justify="start">
                      <h2 className="number-style">{that.state.data.prescription_and_lab_test}</h2>
                    </Row>
                  </Col>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={12}>
            <Card className="health-check-utilization-card" style={{marginBottom: 20,minHeight: 403}}>
              <Card style={{border: 0,backgroundColor: '#e5f8ee',borderRadius: 8}}>
                <h5 className="sub-title">PRESCRIPTIONS UPLOADED FOR PHARMACY ORDERS</h5>
                <h2 className="main-numbers" style={{color: '#1b7042'}}>{that.state.data.prescription_uploaded_after_consultation}</h2>
                <h5 style={{color: '#4d6189'}}>Prescriptions have been uploaded by <span className="semibold">{that.state.data.prescription_uploaded_employee_count}</span> out of <span className="semibold">{that.state.data.only_prescription_given}</span> given</h5>
              </Card>
              <Card style={{marginTop: 20,border: 0,backgroundColor: '#ffeddd',borderRadius: 8}}>
                <Row>
                  <Col span={14}>
                    <h4 className="font-semibold" style={{fontSize: 20,color: '#70411b'}}>Encourage Employees to take Doctor Consultation and be healthy</h4>
                    <h5 style={{fontSize: 14,color: '#9b6d48'}}>Please reach out to <span className="semibold" style={{color: '#2168f3'}}>{sessionStorage.getItem('hr_contact_email')}</span> to learn more</h5>
                  </Col>
                  <Col span={10}>
                    <Row type="flex" justify="end">
                      <img src={ConversationImage}/>
                    </Row>  
                  </Col>
                </Row>
              </Card>
            </Card>
          </Col>
        </Row>
        <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
          <h4 className="sub-heading-title" style={{color: '#8c9197',marginLeft: 0}}>DOCTOR CONSULTATION TRENDS</h4>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <Row type="flex" justify="end">
            <Select 
              defaultValue="last_30days" 
              style={{ width: 200, backgroundColor: '#fff' }} 
              onChange={this.handleChange.bind(this)}
              >
              <Option value="last_30days">Last 30 Days</Option>
              <Option value="last_12_months">Last 12 Months</Option>
              <Option value="last_year">Last Year</Option>
              <Option value="overall">Overall</Option>
            </Select>
          </Row>
          {this.renderChartTrends()}
        </Card>
        </div>
        }
      </div>
    )
  }    
}
export default DoctorConsultations;